export interface IValidation {
    selectedTypes: boolean,
    donorWhyWasKidneyLate: boolean,
    issueDescription: boolean,
    rootCauses: boolean,
    correctiveAction: boolean,
    didSurgeonDiscuss: boolean,
    preSurgicalDiscussionDetails: boolean,
    postSurgicalDiscussionDetails: boolean,
    recipientHaveOrganQualityConcerns: boolean,
    recipientOrganQualityConcernDetails: boolean,
    recipientDidOrganFunctionImmediately: boolean,
    recipientIsOrganCurrentlyFunctioning: boolean,
    requestInvestigation: boolean,
    kidneyReplacementRequest: boolean,
}